import gql from 'graphql-tag';

const DisconnectWearableMutation = gql`
  mutation DisconnectWearable($provider: String!) {
    wearable {
      disconnectProvider(provider: $provider) {
        ... on BasicMutationSuccess {
          code
        }
        ... on UnauthorizedException {
          __typename
        }
        ... on Error {
          name
          description
        }
      }
    }
  }
`;

export default DisconnectWearableMutation;
